import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomainService } from '../../../services/admin/domain.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  estaRedirigiendo: boolean = false;

  constructor(private domainService: DomainService) {
    this.estaRedirigiendo = !!this.domainService.getDomainInfo()?.redireccionTiendaVirtual;

    const navbar = document.getElementById('navbar');
    const toolbar = document.getElementById('toolbar');
    if (navbar && toolbar) {
      navbar.style.display = 'none';
      toolbar.style.display = 'none';
    }
  }

  ngOnInit(): void {
    this.estaRedirigiendo = !!this.domainService.getDomainInfo()?.redireccionTiendaVirtual;
  }

  ngOnDestroy(): void {
    const navbar = document.getElementById('navbar');
    const toolbar = document.getElementById('toolbar');
    if (navbar && toolbar) {
      navbar.style.display = '';
      toolbar.style.display = '';
    }
  }

}
